module.exports = __webpack_public_path__ + "static/media/active_icon.8529cf19.svg";